import React, { Component, Fragment } from 'react';
import $ from 'jquery';
import { message, Modal } from 'antd';
import _ from 'lodash';
import qs from 'query-string';
import { __ } from '@wordpress/i18n';

import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';

const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');
//console.log('VC_CONFIG', window.VC_CONFIG)
const stringToBr = (text) => {
  return _.map(_.split(text, '\n'), (line, idx) => (
    <Fragment key={idx}>
      {line}
      <br />
    </Fragment>
  ));
};
const Local = _.get(window, 'VC_CONFIG.Locale');

// 前端頁面
// 店基本資訊、地圖、美食外送、商店購物
// 美食購物分類、品牌購物分類
// 購物中心樓層介紹 （建議的）
export default class StoreVendor extends Component {
  state = {
    tabType: 'info',
    storeInfo: undefined,
    query: {},
  };

  componentDidMount() {
    this.loadConfig();
    this.setState({
      tabType: AppHelper.getHashValue('tab') || 'info',
    });
    this.loadData();
  }
  loadConfig = () => {
    this.setState({ isLoadingData: true });

    whttp.get(API_HOST + '/api/v1/system/configs', {}, (state, res) => {
      this.setState({ isLoadingData: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      this.setState({ options: data.options }, () => {
        this.refreshPicker();
      });
    });
  };
  loadData = () => {
    const urlQuery = AppHelper.getURLQuery();

    const id = _.get(urlQuery, 'id');

    if (!id) {
      window.location.href = `${window.VC_CONFIG.INDEX_URL}/stores`;
    }

    this.setState({ isFetchData: true });

    whttp.sharedGet(API_HOST + `/api/v1/stores/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/stores');
        return;
      }

      this.setState({ storeInfo: data }, () => {
        this.reloadMaps();
      });
    });
  };
  reloadMaps = () => {
    const { map, maps, storeInfo } = this.state;

    console.log('reloadMaps', map, maps);

    if (!maps || !map || !storeInfo) return;

    const stores = [storeInfo];

    if (!_.isArray(stores) || stores.length === 0) return;

    if (Array.isArray(this.state.markers)) {
      this.state.markers.forEach((marker) => marker.setMap(null));
    }

    // zoom預設為能呈現出地形等高線的大小
    // 所以改成呈現最新的裝置位置
    let bounds = new maps.LatLngBounds();

    const markers = stores.map((store, idx) => {
      const marker = new maps.Marker({
        map: map,
        position: { lat: store.latitude, lng: store.longitude },
        store: store,
      });

      let infowindow = new maps.InfoWindow({
        content: `<div jstcache="33" class="poi-info-window gm-style"> <div jstcache="2"> <div jstcache="3" class="title full-width" jsan="7.title,7.full-width">${
          store.name
        }</div><div class="address"> <div jstcache="4" jsinstance="*0" class="address-line full-width" jsan="7.address-line,7.full-width">${
          store.address
        }</div> </div> </div>`,
      });
      marker.addListener('click', function() {
        infowindow.open(map, marker);
      });
      // marker.addListener('mouseover', function () {
      //   infowindow.open(map, marker);
      // });

      // marker.addListener('mouseout', function () {
      //   infowindow.close();
      // });

      if (idx == 0) {
        bounds.extend(marker.getPosition());
      }
      return marker;
    });

    map.fitBounds(bounds);

    map.setZoom(16);

    this.setState({ markers });
  };
  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh');
  }, 1000);
  handleQueryUpdate = (key, value) => {
    const query = _.get(this, 'state.query', {});
    _.set(query, key, value);
    this.setState({ query });
  };
  getSearchPath = (query) => {
    return (
      window.location.origin +
      `${window.VC_CONFIG.INDEX_URL}/stores/#` +
      qs.stringify(query, { skipNull: true })
    );
  };

  render() {
    const urlQuery = AppHelper.getURLQuery();
    const filterVendorType = parseInt(_.get(urlQuery, 'type', 1), 10);
    const storeInfo = _.get(this, 'state.storeInfo', {});
    const tabType = _.get(this, 'state.tabType', {});
    const options = _.get(this, 'state.options', {});
    const query = _.get(this, 'state.query', {});
    const listInfo = _.get(this, 'props.stores.listInfo', []);
    const banners = _.get(storeInfo, 'banners', []);
    const services = _.get(storeInfo, 'services', []);
    const foods = _.get(storeInfo, 'foods', []);
    const brands = _.get(storeInfo, 'brands', []);
    this.refreshPicker();
    const storeBanner = _.get(storeInfo, 'images.0');
    return (
      <Fragment>
        <div class='bg-light'>
          <div class='container'>
            <div class='breadcrumb-wrap py-4 m-0'>
              <nav aria-label='breadcrumb'>
                <ol class='breadcrumb'>
                  <li class='breadcrumb-item'>
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}${
                        Local == 'en_US' ? '/en' : ''
                      }`}
                    >
                      {__('首頁', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}/stores${
                        Local == 'en_US' ? '-en' : ''
                      }`}
                    >
                      {__('分店搜尋', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}/store-info${
                        Local == 'en_US' ? '-en' : ''
                      }?store=${storeInfo.name}`}
                    >
                      {storeInfo.name}
                    </a>
                  </li>
                  <li
                    class='breadcrumb-item active'
                    aria-current='page'
                    id='name'
                  >
                    {filterVendorType === 1 && '美食外送'}
                    {filterVendorType === 2 && '商店購物'}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
        {/* <div class="banner-location">
          <div class="banner-image">
            <img src={storeBanner ? storeBanner :`${PLUGIN_ASSETS_URL}img/banner/store/banner-store.png`} alt="" />
            <h3 class="title">{storeInfo.name}</h3>
          </div>
          <div class="container map-filter-bar">
            <div class="row justify-content-center no-gutters mx-n2">
              <div class="col-md-3 px-2">
                <div class="form-group">
                  <select
                    className="form-select selectpicker"
                    name="store_area_id"
                    value={query.a}
                    onChange={e => this.handleQueryUpdate('a', e.target.value)}
                  >
                    <option value={undefined} disabled>請選擇城市區域</option>
                    {_.map(_.get(options, 'store_areas', []), item => <option key={item.id} value={item.id}>{item.name}</option>)}
                  </select>
                </div>
              </div>
              <div class="col-md-3 px-2">
                <div class="form-group">
                  <select
                    className="form-select selectpicker"
                    name="store_type_id"
                    value={query.t}
                    onChange={e => this.handleQueryUpdate('t', !isNaN(parseInt(e.target.value, 10)) ? parseInt(e.target.value, 10) : null)}
                  >
                    <option value={undefined} disabled>請選擇分店型態</option>
                    {_.map(_.get(options, 'store_types', []), item => <option key={item.id} value={item.id}>{item.name}</option>)}
                  </select>
                </div>
              </div>
              <div class="col-md-3 px-2">
                <div class="form-group">
                  <select
                    className="form-select selectpicker"
                    name="id"
                    value={query.id}
                    onChange={e => this.handleQueryUpdate('id', !isNaN(parseInt(e.target.value, 10)) ? parseInt(e.target.value, 10) : null)}
                  >
                    <option value={undefined} disabled>請選擇分店</option>
                    {_.map(_.get(listInfo, 'rows', []), item => <option key={item.id} value={item.id}>{item.name}</option>)}
                  </select>
                </div>
              </div>
              <div class="col-md-auto px-2">
                <a className="btn btn-primary btn-search" href={this.getSearchPath(query)}>
                  <i className="icon-search mr-3 mr-md-0"></i><span className="h6 mb-0 d-md-none">搜尋分店</span>
                </a>
              </div>
            </div>
          </div>
        </div> */}

        <main class='bg-light'>
          <div class='container'>
            {_.map(
              _.groupBy(storeInfo.deliveries, (vendor) => vendor.vendor_id),
              (vendors, idx) => {
                let vendorHasIcon = _.find(
                  vendors,
                  (vendor) => vendor.image !== null
                );
                return (
                  <div
                    key={idx}
                    class='my-lg-5 my-3'
                    onClick={(e) => {
                      Modal.info({
                        title: '請選擇品牌',
                        okText: '取消',
                        content: (
                          <div class='row no-gutters mx-n2' id='item'>
                            {vendors.map((vendor, idx) => (
                              <div key={idx} class='col-auto px-2'>
                                <a href={vendor.url}>
                                  <span
                                    class='p btn btn-outline-primary px-3 rounded-pill my-2 service-badge'
                                    role='button'
                                  >
                                    {vendor.brand_name}
                                  </span>
                                </a>
                              </div>
                            ))}
                          </div>
                        ),
                      });
                    }}
                  >
                    <img
                      role='button'
                      class='img-cover'
                      src={vendorHasIcon.image}
                      alt={vendorHasIcon.vendor_name}
                    />
                  </div>
                );
              }
            )}
            {/*_.map(_.filter(storeInfo.deliveries, vendor => vendor.vendor_type === filterVendorType), (vendor, idx) => (
              <div class="my-lg-5 my-3"><a href={vendor.url}><img class="img-cover" src={vendor.image} /></a></div>
            ))*/}
          </div>
        </main>
      </Fragment>
    );
  }
}

// 編輯器
export class StoreVendorEditor extends Component {
  render() {
    return <div className='vu-blocks-editor'>編輯器</div>;
  }
}



// WEBPACK FOOTER //
// ./src/blocks/stores/store-vendor.js